const reviewcheck = setInterval(myTimer, 1000);

function myTimer() {
    if ( $('.spr-badge-caption').length > 0 ){
         $('<span class="trigger_write_review">Write a review</span>').insertAfter(".spr-badge-caption");
            $('.trigger_write_review').click(function(){
              $('html, body').animate({
                scrollTop: $("#shopify-product-reviews").offset().top
              }, 1000);
              $('.spr-summary-actions-newreview').trigger('click');
            });
            $(".spr-badge-caption").click(function(){
              $('html, body').animate({
                scrollTop: $("#shopify-product-reviews").offset().top
              }, 1000);
            });
        myStopFunction();
    }
}

function myStopFunction() {
  clearInterval(reviewcheck);
}